/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
// eslint-disable-next-line no-control-regex
import React,{ forwardRef, useRef,useState,useCallback,useEffect} from 'react';
import { debounce ,formatDateByTimezone} from '../../utils/commonFunctions.js';
import moment from "moment";
import { useNavigate } from "react-router-dom";
import {APIEndpoint } from "../../utils/axios";
import closeIcon from "../../images/icons/Icon2.png";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



const Header = forwardRef(({headerProp},ref) => {
   const {
filters,
inputFieldFocus,
checkedItemsList,
setScanHistoryArray,
setScannerData,
isLoading,
itemMasterAll,
setItemMasterAll,
filterItemsType
  }=headerProp;
const debouncedFetchRef = useRef();
const initialLoading=useRef(false);
const inputRef = useRef(null);
const barcodeItemCacheRef = useRef(new Map());

const [state,setState]=useState({startDate:null,isOpenMenu:false,catGroup:[]})

const [message,setMessage]=useState({text:'',duration:null});
const [sectors,setSectors]=useState([]);
const navigate = useNavigate();


const showToast = useCallback(()=>{
  toast.dismiss();
  if (message.text) {
    toast.success(message.text, {
      position: toast.POSITION.TOP_CENTER,
      hideProgressBar: true,
      pauseOnHover: true,
      draggable: false,
      autoClose: message.duration??3800,
      style: {
        backgroundColor: '#4cae4c',
        color: '#fff',
        borderRadius: '8px',
        fontSize: '1rem',
        width:'30rem'
      }
    });
  } else if (message.error) {
    toast.error(message.error, {
      position: toast.POSITION.TOP_CENTER,
      hideProgressBar: true,
      pauseOnHover: true,
      draggable: false,
      autoClose:  message.duration??3800,
      style: {
        backgroundColor: '#d9534f',
        color: '#fff',
        borderRadius: '8px',
        fontSize: '1rem',
        width:'30rem'
      }
    });
  } else {

  }
},[message])

useEffect(() => {
  if (inputRef.current && !(state.startDate && state.catGroup.length > 0 )) {
    inputRef.current.focus();
    inputRef.current.value='';

  }
}, [state.startDate, state.catGroup, checkedItemsList,itemMasterAll,inputFieldFocus,sectors,message,filterItemsType]);

useEffect(() => {
if (!message.text && !message.error) return;
showToast();
const timer = setTimeout(() => {
setMessage({ text: "" });
}, message.duration??4000);
return () => clearTimeout(timer);
}, [message.text, message.error, showToast]);

useEffect(() => {
  if(filters){
    if(!itemMasterAll.length && !sectors.length && !initialLoading.current){
    fetchScannerItemsAndFilters();
    }
    setState((_)=>({..._,startDate:filters.targetDate,}))
  }
  }, [filters])

const itemTypeScanned=()=>{
  for (let i in filterItemsType) {
  if (Boolean(filterItemsType[i].checked)) {
    return i.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, (char) => char.toUpperCase());
  }
}
}
const onChangeBarCode = (e) => {
  const raw = e.target.value.trim();
  // eslint-disable-next-line no-control-regex
  const searchCode = raw.replace(/[\x00-\x1F\x7F-\x9F\u200B-\u200D\uFEFF]/g, '');
  if (searchCode && debouncedFetchRef.current) {
    debouncedFetchRef.current(searchCode);
  }
};

const updateScanHistory = (status, sId, itemType) => {
  setScanHistoryArray((prev) => {
    const newHistory = (prev ?? []).map((entry) =>
      (entry.scanId === sId &&  entry.itemType === itemType) ? { ...entry, status,itemType } : entry
    );
    return newHistory;
  });
};

const fetchBarCodeOnId = useCallback(
  async (searchCode) => {
    let foundItem = false;
    setMessage({ text: "", duration: null });

    setScanHistoryArray((prev) => {
      const newHistory = [...(prev ?? [])];
      newHistory.push({
        key: searchCode,
        scanId: searchCode,
        scanTime: moment().format("DD-MM-YY hh:mm A"),
        itemType:itemTypeScanned(),
        status: "Scanning...",
      });
      return newHistory;
    });

    const cachedItemId = barcodeItemCacheRef.current.get(searchCode);

    if (cachedItemId) {
      const { itemId, itemName, dutyFree } = cachedItemId;
      if (itemName === 'NOT_FOUND' && !itemId) {
        setTimeout(() => {
          updateScanHistory("Not Found", searchCode,itemTypeScanned());
          setMessage({ error: `No Item available with Barcode: ${searchCode}`, duration: 1500 });
        }, 0);
        return;
      }
if (
  itemName && 
  itemId && 
  !filterItemsType.all.checked && 
  (
    (dutyFree && filterItemsType.dutyPaid.checked) || 
    (dutyFree === false && filterItemsType.dutyFree.checked)
  )
) {
  setTimeout(() => {
    updateScanHistory("Not Found", searchCode,itemTypeScanned());
    setMessage({ error: `No Item available with Barcode: ${searchCode}`, duration: 1500 });
  }, 0);
  return;
}

      foundItem = true;

      setScannerData((prev) => updateScannerData(prev, cachedItemId));
      
      setTimeout(() => {
        setMessage({ text: `${itemName} count incremented by 1`, duration: 1500 });
        updateScanHistory("Success", searchCode,itemTypeScanned());
      }, 0);
      return;
    }


    const barCodeItem = itemMasterAll.find((item) => item.barcode === searchCode);
 
    
    if (barCodeItem) {
      const { dutyFree,itemId } = barCodeItem;
      if (!filterItemsType.all.checked) {
        if ((dutyFree && filterItemsType.dutyFree.checked) || (!dutyFree && filterItemsType.dutyPaid.checked)) {
          setScannerData((prev) => updateScannerData(prev, barCodeItem));
        } else {

          setTimeout(() => {
            updateScanHistory("Not Found", searchCode,itemTypeScanned());
            setMessage({ error:`No Item available with Barcode: ${searchCode}`, duration: 1500 });
          }, 0);
        }
      } else {
        if(filters){
          const availableItems = new Set(filters.items.map(item => item.itemId));

          if(availableItems.has(itemId)){
              setScannerData((prev) => updateScannerData(prev, barCodeItem));
              barcodeItemCacheRef.current.set(searchCode, {
              itemId: barCodeItem.itemId,
              itemName: barCodeItem.itemName,
              dutyFree: barCodeItem.dutyFree,
              });
              return;
          } else{
                 setTimeout(() => {
            updateScanHistory("Not Found", searchCode,itemTypeScanned());
            setMessage({ error:`No Item available with Barcode: ${searchCode}`, duration: 1500 });
          }, 0);
          }     
        }
      }

  
    }
    if (!foundItem) {
      barcodeItemCacheRef.current.set(searchCode, { itemId: null, itemName: 'NOT_FOUND', dutyFree: undefined });
      updateScanHistory("Not Found", searchCode,itemTypeScanned());
      setMessage({ error: `No Item available with Barcode: ${searchCode}`, duration: null });
    }
  },
  [itemMasterAll, filters, filterItemsType]
);
 

const updateScannerData = (prev, barCodeItem) => {
  const existingItems = prev?.items ?? [];
  const matchedItems = filters?.items?.filter((item) => item?.itemId === barCodeItem.itemId) ?? [];

  matchedItems.forEach((item) => {
    item.totalUplifted = (item.totalUplifted ?? 0) + 1;
  });

  if (matchedItems.length > 0) {

    barcodeItemCacheRef.current.set(barCodeItem.barcode, {
      itemId: barCodeItem.itemId,
      itemName: barCodeItem.itemName,
      dutyFree: barCodeItem.dutyFree,
    });
    updateScanHistory("Success", barCodeItem.barcode,itemTypeScanned());
    setMessage({ text: `Found Item: ${barCodeItem?.itemName}`, duration: 1500 });
  }

  const totScannedObj = [...existingItems, ...matchedItems];

  const newItemIndex = totScannedObj.findIndex((item) => item.itemId === barCodeItem.itemId);
  if (newItemIndex !== -1) {
    const [updatedScan] = totScannedObj.splice(newItemIndex, 1);
    totScannedObj.unshift(updatedScan);
  }

  const uniqueItems = Array.from(
    new Map(totScannedObj.map((item) => [item.itemId, item])).values()
  );

  return { ...prev, items: uniqueItems };
};




useEffect(() => {
  debouncedFetchRef.current = debounce((code) => {
    fetchBarCodeOnId(code);
  },100);
}, [fetchBarCodeOnId,itemMasterAll]);

  const fetchItemMasterAll = async (page = 1, perPage = 50) => {
    const filterData = {
      action: 4,
      collection: '',
      filterOperation: 'or',
      filters: [],
      limit: perPage,
      page: page,
      searchParam: ''
    };

    try{
      const res = await APIEndpoint.post('master/process', filterData);
      if(res){
      return res;
      }
    }
    catch(err){

    }

  }


  async function getItemMasterAll() {
    try {
      const initialRes = await fetchItemMasterAll(1, 1);

      if (
        initialRes?.count &&
        Array.isArray(initialRes.items) &&
        initialRes.items.length 
      ) {
        const fullRes = await fetchItemMasterAll(1, initialRes.count);
        setItemMasterAll([...fullRes.items]);
        return true;
      }else{
        return false;
      }
    } catch (error) {
      return false;
    }
  }

  function handleKeyDown(e){
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }

  async function fetchScannerItemsAndFilters() {
    try {
      initialLoading.current=true;
      const [sectors, itemsAll] = await Promise.all([
        APIEndpoint.get('stores'),
        getItemMasterAll()
      ]);


      if (sectors?.success && Array.isArray(sectors.result) && itemsAll) {
        const sectorList = sectors.result.map((data) => ({
          key: data.id,
          label: `${data.flightNumber}-${data.origin}-${data.destination}`,
          value: data.id,
        }));

        if (sectorList.length > 0) {
          setSectors(sectorList);
        }

      }
    } catch (error) {
      console.error("Error :", error);
    }
  }

 function goBack() {
      navigate(-1);
    }
function getScanScreenMode() {
  if (!filters) return "";
  if (filters.reconId && !filters.upliftEstimateId) {
    return 'Edit Reconciliation - ';
  } else if (!filters.reconId && !filters.upliftEstimateId) {
    return 'New Reconciliation - ';
  } else {
    return 'Uplifts - ';
  }
}

  return (
    <div className="header" style={{position:'relative',zIndex:1000,top:0}}>
      <div className="flexRow justifyContentSpaceBetween alignItemsCenter content-tabs filters">
{state.startDate?<>
 <div className="se-scanner-la3">
 {getScanScreenMode()}{moment(formatDateByTimezone(state.operatingDate ? new Date(state.operatingDate) : new Date())).format("DD-MM-YYYY")} - {filters?.storeName?sectors.find(option => option.label === filters?.storeName?.replaceAll(" ",""))?.label:sectors.find(option => option.value === filters?.storeId)?.label || null}
 </div>

<div className='flexRow justifyContentFlexEnd margTop11'>
<button onClick={goBack}>
<img src={closeIcon} alt="close" data-icon='close'/>
</button>
        </div></> :null}
      </div>

    {!(state.startDate && state.catGroup.length>0 && !Object.keys(filters).length===0)?  <input   onKeyDown={handleKeyDown} ref={inputRef} className="barcode-input" disabled={isLoading||(!itemMasterAll.length && !sectors.length)} type="text" name="barcode" onChange={onChangeBarCode} placeholder="Please enter a barcode or enable scanning to list items..." />:<></>}
    <ToastContainer/>

    </div>
  );
})
export default Header;